import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {currentUserHasAccess, PermissionName} from './currentUserHasAccess';

export const currentUserHasUploadAccess = (): boolean => {
	if (!currentUserMeetsUserLevel(UserLevel.IMPORTER)) return false;
	return currentUserHasAccess(PermissionName.UPLOAD);
};
